import React from "react";
import { locationPin } from "../../../assets/images";
import { VehicleType } from "../../../types";
import { ipfsGatewayImage } from "../../../utils/ipfsGatewayImage";
import { useDispatch } from "react-redux";
import { setBrandFilter } from "../../../redux/slices/vehicleFilterSlice";
import { useNavigate } from "react-router-dom";

type CarProps = {
  vehicle: VehicleType;
};

const Car: React.FC<CarProps> = ({ vehicle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        dispatch(setBrandFilter(vehicle.make));
        navigate("/vehicles");
      }}
      className="flex flex-col justify-between bg-white w-[383px] h-[310px] flex-shrink-0 p-[20px] hover:shadow-md hover:shadow-lightGreen cursor-pointer "
    >
      <div className="w-[296px] h-[150px] mx-auto">
        <img
          src={ipfsGatewayImage(vehicle?.carImages[0]?.imageUrl ?? "")}
          alt=""
          className="h-full w-full object-cover"
        />
      </div>
      <hr />
      <div className="flex flex-col justify-end ">
        <div className=" flex justify-between">
          <h3 className="text-darkText  font-Poppins font-semibold text-[32px]  tracking-tight">
            {vehicle.make}
          </h3>
          {/* <img src={locationPin} alt="" /> */}
        </div>
        {/* <div className="flex justify-between">
          <p className="font-Poppins text-lightGreyText text-[8px] md:text-[16px] font-light uppercase">
            {car.type}
          </p>
          <p className="text-lightGreyText font-Poppins font-light text-[8px] md:text-[16px]">
            {car.location}{" "}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default Car;
